export const DEFAULT_FAQ_BLOCK_TITLE = 'Frequently Asked Questions'

export function resolveFaqBlockTitle(faqTitle) {
  if (typeof faqTitle !== 'string') {
    return DEFAULT_FAQ_BLOCK_TITLE
  }

  return faqTitle.trim() || DEFAULT_FAQ_BLOCK_TITLE
}
